
// Telefonnummer prüfen
export const isValidTelefon = (telefon: string) => {
  if (telefon==='') return true // Es ist erlaubt, dass keine Telefonnummer angegeben wird
  if ( telefon.length < 5 ) return "Die Nummer ist zu kurz"
  if ( telefon.match(/00000/gm)
    || telefon.match(/^01234.*$/)
    || !telefon.match(/^[+0].*/)
    || telefon.match(/---/gm)
  ) return "Diese Nummer ist nicht gültig"
  return true
}